<template>
	<div ref="chart" :id="uuid" class="stockEchart"></div>
</template>

<script>
import { getUuid } from '@/utils/api';
const eCharts = require('echarts');
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			chart: null,
			uuid: 'bar-' + getUuid(5)
		};
	},
	props: {
		xData: {
			type: Array,
			default: () => []
		},
		yBarData: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		...mapGetters(['getIrThemeColor'])
	},
	mounted() {},
	methods: {
		initEchart() {
			if (!this.$refs.chart) return;
			if (this.chart) {
				this.chart.clear();
				this.chart.dispose();
				this.chart = null;
			}

			let max = Math.ceil(Math.max(...this.yBarData));
			let chartDom = document.querySelector('#' + this.uuid);
			this.chart = eCharts.init(chartDom);
			let option = {
				grid: {
					top: 24,
					left: 0,
					right: 0,
					bottom: 40
				},
				barWidth: 15,
				tooltip: {
					trigger: 'axis',
					confine: true,
					axisPointer: {
						type: 'shadow',
						shadowStyle: {
							color: 'rgba(0, 0, 0, 0.03)'
						}
					},
					backgroundColor: 'rgba(255,255,255,0.8)',
					textStyle: {
						color: '#333' //设置文字颜色
					}
				},
				xAxis: [
					{
						type: 'category',
						data: this.xData,
						axisTick: {
							//y轴刻度线
							show: false
						},
						axisLabel: {
							color: 'rgba(0,0,0,.5)',
							fontWeight: 400,
							fontFamily: 'PingFang SC',
							formatter: function (value, index) {
								let arr = value.split('-');
								let target = `${arr[1]}-${arr[2]}` + '\n' + `${arr[0]}`;
								return target;
							}
						},
						axisLine: {
							lineStyle: {
								color: '#E8EAEF'
							}
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						min: 0,
						max: max,
						interval: max / 2,
						axisLabel: {
							formatter: '{value}'
						},
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false //去掉网格线
						}
					}
				],
				series: [
					{
						name: `${this.$t('enterprise.number-of-shareholders')}
						(${this.$t('enterprise.thousand-households')})`,
						type: 'bar',
						yAxisIndex: 0,
						itemStyle: {
							normal: {
								color: this.getIrThemeColor
							}
						},
						label: {
							show: true,
							position: 'top',
							fontWeight: 400,
							fontFamily: 'DIN Alternate',
							color: this.getIrThemeColor
						},
						data: this.yBarData
					}
				]
			};

			option && this.chart.setOption(option);
		}
	},
	watch: {
		xData: {
			handler(newVal, oldVal) {
				this.$nextTick(function () {
					newVal && newVal.length && this.initEchart();
				});
			},
			deep: true,
			immediate: true
		},
		getIrThemeColor() {
			this.$nextTick(function () {
				this.initEchart();
			});
		}
	}
};
</script>

<style lang="less" scoped>
.stockEchart {
	width: 100%;
	height: 2rem;
}
</style>
